import type { JSX } from 'react'
import type { IPopupProps } from '../Popup'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { PopupHeaderCroppedTemplate } from 'blocks/TextBlock/Templates/Popup/PopupHeaderCroppedTemplate'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Popup } from '../Popup'
import { PopupPaddings, PopupRowGap } from '../Popup.h'
import { TOAPopupSC } from '../Popup.styled'

export interface ITOAPopupProps extends IPopupProps {
  title?: string
  subtitle?: string
  emptyBody?: boolean
}

export const TOAPopup = ({
  title,
  subtitle,
  children,
  width = '33rem',
  padding = PopupPaddings.SIZE_40, //[72px,56px,56px]
  rowGap = PopupRowGap.INDENT_0, //0px
  isCloseBtnShown = false,
  headerBackground = COLOR.SURFACE_DARK_4,
  popupBackground = COLOR.SURFACE_DARK_4,
  ...rest
}: ITOAPopupProps): JSX.Element => (
  <TOAPopupSC>
    <Popup
      width={width}
      padding={padding}
      rowGap={rowGap}
      isCloseBtnShown={isCloseBtnShown}
      headerBackground={headerBackground}
      popupBackground={popupBackground}
      {...rest}
    >
      <>
        {title && (
          <PopupHeaderCroppedTemplate
            font={TextBoxTypes.FontLgBold}
            title={title}
            verticalPaddings={[FIXED_INDENTS.INDENT_0, FIXED_INDENTS.INDENT_60]}
          />
        )}
        {subtitle && (
          <TextBox
            title={subtitle}
            font={TextBoxTypes.FontSmBold}
            color={TextBoxColors.TEXT_ICON_SECONDARY}
            maxLines={2}
          />
        )}
      </>
      {children}
    </Popup>
  </TOAPopupSC>
)
